<template lang="html">
  <div class="cw-intro">
    <section class="header hero is-charcoal is-padded-large is-bold">
      <div
        class="hero-body has-text-centered centerit is-horizontal is-paddingless"
      >
        <section class="section is-paddingless">
          <img
            class="hero-auto-margin"
            src="https://red.callcw.com/assets/img/logo/red-trans-invert.svg"
          />
          <p class="tagline font-light">
            Managing rolloffs has never been easier.
          </p>
        </section>
        <section class="section centerit is-padded-small login-section">
          <div class="columns is-mobile">
            <p class="column">
              <router-link
                to="/register"
                class="button is-large is-primary is-outlined is-rounded"
                >Register</router-link
              >
            </p>
            <p class="column">
              <router-link
                to="/login"
                class="button is-large is-primary is-rounded"
                >Login</router-link
              >
            </p>
          </div>
        </section>
      </div>
    </section>
    <section class="is-padded-large has-text-centered">
      <!-- <div class="is-padded-large"> -->
      <h2 class="title is-size-2 is-padded-medium">Web and Mobile App</h2>
      <div class="centerit">
        <app-store-buttons />
      </div>
      <div>
        <img
          class="devices-preview"
          src="https://red.callcw.com/assets/img/prev/two-devices.jpg"
          alt="App on web and mobile phone."
        />
      </div>
      <!-- </div> -->
    </section>
    <features-overview />
    <mobile-app-links />
    <section
      class="section is-charcoal is-horizontal-paddingless description centerit is-horizontal"
    >
      <div
        class="section centerit is-padded-small login-section has-text-centered"
      >
        <div class="columns">
          <p class="column">
            <router-link
              to="/register"
              class="button is-large is-primary is-outlined is-rounded"
              >Register</router-link
            >
          </p>
          <p class="column">
            <router-link
              to="/login"
              class="button is-large is-primary is-rounded"
              >Login</router-link
            >
          </p>
        </div>
      </div>
      <div class="is-readable-width has-text-centered hero-auto-margin">
        <p class="is-size-4 is-padded-medium has-text-grey-medium">
          CW is a locally owned Central Indiana waste processing, disposal, and
          recycling company, offering dumpsters at flat rates, without
          additional fees and charges.
        </p>
        <p class="is-padded-large">
          <a
            href="http://callcw.com"
            target="blank"
            class="button is-white is-outlined is-rounded is-large"
            >More</a
          >
        </p>
        <cw-app-version />
      </div>
    </section>
  </div>
</template>

<script>
import FeaturesOverview from '@/components/blocks/FeaturesOverview';
import MobileAppLinks from '@/components/blocks/MobileAppLinks';
import AppStoreButtons from '@/components/blocks/AppStoreButtons';

export default {
  name: 'cw-intro',
  // share common functionality with component mixins
  mixins: [],
  props: {},
  // variables
  data() {
    return {};
  },
  computed: {},
  components: {
    FeaturesOverview,
    MobileAppLinks,
    AppStoreButtons,
  },
  // methods
  watch: {},
  methods: {},
};
</script>

<style lang="stylus" scoped>

.hero-auto-margin {
  margin: auto
  padding-left: 2vw
  max-width: 50em
}
.login-section {
  .button {
    min-width: 8em
  }
}
.header {
  min-height: 50vh
  padding-top: 5rem
  .tagline {
    margin: 2rem 0
    font-size: 1.5rem
  }
  .hero-body{
    // display: flex;
  }
}
.devices-preview {
  width: 800px
}
</style>
